// Define dataLayer and the gtag function.

type ConsentPermission = 'denied' | 'granted';

window.dataLayer = window.dataLayer || [];
function gtag(
  ..._args: [
    'consent',
    'default' | 'update',
    {
      ad_storage?: ConsentPermission;
      analytics_storage: ConsentPermission;
      functionality_storage?: ConsentPermission;
      personalization_storage?: ConsentPermission;
      security_storage?: ConsentPermission;
      ad_user_data?: ConsentPermission;
      ad_personalization?: ConsentPermission;
    },
  ]
): void {
  window.dataLayer.push(arguments);
}

function generateConsent(consent: Record<string, boolean>): Record<string, ConsentPermission> {
  let consentVal = {};
  if (consent) {
    consentVal = Object.keys(consent)?.reduce((pre, cur) => {
      pre[cur] = consent[cur] ? 'granted' : 'denied';
      return pre;
    }, {} as any);
  }

  return consentVal;
}

export class ConsentMode {
  defaultGrantAll(consent: Record<string, boolean>): void {
    gtag('consent', 'default', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ...generateConsent(consent),
    });
  }
  defaultDenyAll(consent: Record<string, boolean>): void {
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ...generateConsent(consent),
    });
  }
  updateGrantAll(consent: Record<string, boolean>): void {
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ...generateConsent(consent),
    });
  }
  updateDenyAll(consent: Record<string, boolean>): void {
    gtag('consent', 'update', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ...generateConsent(consent),
    });
  }

  initializeWithConsent(consent: Record<string, boolean>): void {
    if (consent['ga'] || consent['optional']) {
      this.defaultGrantAll(consent);
    } else {
      this.defaultDenyAll(consent);
    }
  }

  updateWithConsent(consent: Record<string, boolean>): void {
    if (consent['ga'] || consent['optional']) {
      this.updateGrantAll(consent);
    } else {
      this.updateDenyAll(consent);
    }
  }
}

const instance = new ConsentMode();
export default instance;
export type IConsentMode = typeof instance;
